module.exports = __webpack_public_path__ + "static/media/ArgentinianNights.36febea4.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./public/fonts/ArgentinianNights.ttf
 ** module id = 886
 ** module chunks = 44
 **/